import { futureCVTranslate } from '../../i18n/translatedMessages.js'

export function BoxSalary({ comparative }) {
	return (
		<div className='tw-p-4 tw-rounded-md tw-bg-gray-50 border tw-flex tw-flex-col tw-items-center tw-justify-center'>
			<p className='tw-text-sm'>{futureCVTranslate.riskTitleFutureCV}</p>
			{comparative < -15 ? (
				<p className='tw-text-error-500 tw-text-xl tw-font-bold'>{futureCVTranslate.riskHighTextFutureCV}</p>
			) : comparative >= -14.9 && comparative <= 14.9 ? (
				<p className='tw-text-blue-500 tw-text-xl tw-font-bold'>{futureCVTranslate.riskMediumTextFutureCV}</p>
			) : comparative >= 15 ? (
				<p className='tw-text-green-500 tw-text-xl tw-font-bold'>{futureCVTranslate.riskLowTextFutureCV}</p>
			) : (
				''
			)}
		</div>
	)
}
